import React from 'react';
import { Column, flexRender } from '@tanstack/react-table';
import { camelCaseToSpace } from '../../../../utils/case';

export const getHeaderTitle = (column: Column<any, any>): React.ReactNode => {
  if (typeof column.columnDef.header === 'function') {
    return flexRender(column.columnDef.header, {} as any);
  }
  return camelCaseToSpace(column.id);
};
